import axios from 'axios'

export const getPricings = (params) => {
  return axios.get('pricings', { params: params })
}

export const getPlans = (id, params) => {
  return axios.get('plan/' + id, { params: params })
}

export const subscription = (data) => {
  return axios.post('user/subscription', data)
}
export const subscriptionNew = (data) => {
  return axios.post('user/subscription-new', data)
}

export const updateTransaction = (data) => {
  return axios.post('user/update-transaction', data)
}

export const unSubscription = (data) => {
  return axios.post('user/cancel-subscription', data)
}

export const updateCard = (data) => {
  return axios.post('user/update-card', data)
}

export const getHistories = (data) => {
  return axios.get('user/invoices', data)
}

export const checkCoupon = (id) => {
  return axios.get('coupon_check/' + id)
}



// WEBPACK FOOTER //
// ./src/api/payments.js